<template>
  <div class="flex-1 p-4 text-sm">

    <div class="mt-3" style="min-width: 500px;">
      <div class="text-transparent text-xs">{{reload}}</div>

      <InputGroupSubLabel
        name="work"
        caption="業務依頼"
      />

      <!-- 詳細カテゴリー -->
      <SelectionOneValue
        caption="業務依頼詳細カテゴリー（1つのみ）"
        v-model="rp.workCategory"
        :list="workSelections"
        :required="false"
        :disabled="referenceMode"
        class="mt-3"
      ></SelectionOneValue>

      <!-- 備考 -->
      <WmsTextInput
        name="note"
        caption="備考"
        v-model="rp.workNote"
        :disabled="referenceMode"
        :multiline="true"
        :rows="5"
        class="mt-3"
      />
    </div>
  </div>
</template>

<script>
  import SelectionOneValue from '@components/SelectionOneValue.vue'
  import InputGroupSubLabel from '../components/InputGroupSubLabel.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'

  export default {
    components: {
      SelectionOneValue,
      InputGroupSubLabel,
      WmsTextInput
    },

    props: {
      rp: {
        type: Object,
        default: () => {}
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {
        reload: 0,
        workSelections: [
          { id: '発注申請', name: '発注申請' },
          { id: '振込依頼', name: '振込依頼' },
          { id: '勤務シフト', name: '勤務シフト' },
          { id: 'その他', name: 'その他' }
        ]
      }
    },

    methods: {
    }
  }
</script>

<style scoped>
</style>